import React, { useState, useEffect } from 'react';
import {
  Box, Card, CardContent, Typography, Grid, Avatar, Chip, Divider,
  Stack, Button, CircularProgress, Alert, Paper, LinearProgress, Badge
} from '@mui/material';
import {
  Business, Email, Phone, LocationOn, Verified, AccountBalanceWallet,
  MonetizationOn, Hotel, CalendarToday, Security, Edit, FileCopy
} from '@mui/icons-material';
import axios from 'axios';
import { KeyUri, config } from "../key";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import { Snackbar, Alert as MuiAlert } from '@mui/material';
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  listAll,
  getStorage,
} from "firebase/storage";
//import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import {storage} from '../firebaseconfig';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';

const VendorProfile = () => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
const [editOpen, setEditOpen] = useState(false);
const [docsOpen, setDocsOpen] = useState(false);
const [selectedFiles, setSelectedFiles] = useState([]);
const [uploading, setUploading] = useState(false);
const [newDocType, setNewDocType] = useState('GST'); 

const [form, setForm] = useState({
  companyName: '',
  businessType: '',
  registrationNumber: '',
  gstNumber: '',
  panNumber: '',
  street: '',
  city: '',
  state: '',
  pincode: '',
  country: 'India',
  documents: [],
  accountHolderName: '',
  accountNumber: '',
  ifscCode: '',
  bankName: '',
  branch: '',
  accountType: '',
  upiVpa: '',
  upiName: '',
});

const [snackbar, setSnackbar] = useState({
  open: false,
  message: '',
  severity: 'success',
});

const handleCloseSnackbar = (_, reason) => {
  if (reason === 'clickaway') return;
  setSnackbar((prev) => ({ ...prev, open: false }));
};

  useEffect(() => {
    fetchVendorProfile();
  }, []);

  useEffect(() => {
  if (vendor) {
    setForm({
      companyName: vendor.companyName || '',
      businessType: vendor.businessType || '',
      registrationNumber: vendor.registrationNumber || '',
      gstNumber: vendor.gstNumber || '',
      panNumber: vendor.panNumber || '',
      street: vendor.address?.street || '',
      city: vendor.address?.city || '',
      state: vendor.address?.state || '',
      pincode: vendor.address?.pincode || '',
      country: vendor.address?.country || 'India',
      documents: vendor.documents || [],
      accountHolderName: vendor.bankDetails?.accountHolderName || '',
      accountNumber:     vendor.bankDetails?.accountNumber || '',
      ifscCode:          vendor.bankDetails?.ifscCode || '',
      bankName:          vendor.bankDetails?.bankName || '',
      branch:            vendor.bankDetails?.branch || '',
      accountType:       vendor.bankDetails?.accountType || '',
      upiVpa:            vendor.bankDetails?.upiVpa || '',
      upiName:           vendor.bankDetails?.upiName || '',
    });
  }
}, [vendor]);

const handleChange = (e) => {
  setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
};

const uploadDocumentToFirebase = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) return reject(new Error('No file selected'));

    const path = `vendor-documents/${vendor._id}/${Date.now()}-${file.name}`;
    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      () => {}, 
      (error) => reject(error),
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(url);
      }
    );
  });
};

const updateDocumentsInDb = async (newDocuments) => {
  const token = localStorage.getItem('vendorToken');

  const payload = {
    companyName: form.companyName,
    businessType: form.businessType,
    registrationNumber: form.registrationNumber,
    gstNumber: form.gstNumber,
    panNumber: form.panNumber,
    street: form.street,
    city: form.city,
    state: form.state,
    pincode: form.pincode,
    country: form.country,
    documents: newDocuments,
  };

  const res = await axios.put(
    KeyUri.BACKEND_URI + '/vendor-update-profile',
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  setVendor(res.data.vendor);
  setForm((prev) => ({ ...prev, documents: res.data.vendor.documents || [] }));
};

const handleUpdate = async () => {
  try {
    const token = localStorage.getItem('vendorToken');
    const res = await axios.put(
      KeyUri.BACKEND_URI + '/vendor-update-profile',
      {
        companyName:        form.companyName,
        businessType:       form.businessType,
        registrationNumber: form.registrationNumber,
        gstNumber:          form.gstNumber,
        panNumber:          form.panNumber,
        street:             form.street,
        city:               form.city,
        state:              form.state,
        pincode:            form.pincode,
        country:            form.country,
        documents:          form.documents,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setVendor(res.data.vendor);
    setEditOpen(false);
    setSnackbar({ open: true, message: 'Profile updated successfully', severity: 'success' });
  } catch (err) {
    console.error('Update error:', err.response?.data || err.message);
    setSnackbar({ open: true, message: err.response?.data?.message || 'Failed to update profile', severity: 'error' });
  }
};

const handleSaveBankDetails = async () => {
  try {
    const token = localStorage.getItem('vendorToken');

    const res = await axios.put(
      KeyUri.BACKEND_URI + '/payment-details',
      {
        accountHolderName: form.accountHolderName,
        accountNumber:     form.accountNumber,
        ifscCode:          form.ifscCode,
        bankName:          form.bankName,
        branch:            form.branch,
        accountType:       form.accountType,
        upiVpa:            form.upiVpa,
        upiName:           form.upiName,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // Update vendor state with new bank details
    setVendor(prev => ({
      ...prev,
      bankDetails: res.data.paymentDetails
    }));

    setSnackbar({
      open:     true,
      message:  'Bank details saved successfully',
      severity: 'success',
    });

  } catch (err) {
    console.error('Bank details error:', err.response?.data || err.message);
    setSnackbar({
      open:     true,
      message:  err.response?.data?.message || 'Failed to save bank details',
      severity: 'error',
    });
  }
};

  const fetchVendorProfile = async () => {
    try {
      const token = localStorage.getItem('vendorToken');
      const response = await axios.get(KeyUri.BACKEND_URI + '/vendor/profile', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setVendor(response.data.vendor);
    } catch (err) {
         console.error('Profile error:', err.response?.status, err.response?.data);
      setError('Failed to load profile data');
    } finally {
      setLoading(false);
    }
  };

  const getStatusConfig = (status) => {
    const config = {
      verified: { color: 'success', icon: Verified, label: 'Verified' },
      pending: { color: 'warning', icon: CalendarToday, label: 'Pending Review' },
      rejected: { color: 'error', icon: Security, label: 'Rejected' }
    };
    return config[status] || config.pending;
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3 }}>
          <CircularProgress size={48} thickness={4} />
          <Typography variant="h6" mt={2} color="text.secondary">
            Loading profile...
          </Typography>
        </Paper>
      </Box>
    );
  }

  if (error || !vendor) {
    return (
      <Alert severity="error" sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
        {error || 'Vendor profile not found'}
      </Alert>
    );
  }

  const statusConfig = getStatusConfig(vendor.verificationStatus);
  const StatusIcon = statusConfig.icon;

  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
        py: 5,
        mt: {xs: 10, md: 22},
        mb: 4,
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4ecf7 100%)',
        minHeight: '100vh'
      }}
    >
      {/* Header Hero Section */}
      <Paper
        elevation={8}
        sx={{
          borderRadius: 4,
          overflow: 'hidden',
          mb: 5,
          background: 'linear-gradient(135deg, #3949ab 0%, #5c6bc0 50%, #7e57c2 100%)',
          color: 'common.white'
        }}
      >
        <Box sx={{ p: { xs: 3, md: 5 } }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={3} textAlign="center">
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={
                  <Chip
                    icon={<StatusIcon />}
                    label={statusConfig.label}
                    size="small"
                    color={statusConfig.color}
                    sx={{
                      fontSize: '0.7rem',
                      bgcolor: 'rgba(255,255,255,0.9)',
                      color: 'text.primary'
                    }}
                  />
                }
              >
                <Avatar
                  sx={{
                    width: { xs: 80, md: 110 },
                    height: { xs: 80, md: 110 },
                    mx: 'auto',
                    bgcolor: 'rgba(255,255,255,0.15)',
                    fontSize: { xs: '2rem', md: '2.6rem' }
                  }}
                >
                  <Business />
                </Avatar>
              </Badge>
            </Grid>

            <Grid item xs={12} md={9}>
              <Stack spacing={1}>
                <Typography
                  variant="h3"
                  fontWeight={800}
                  sx={{ letterSpacing: '-0.02em' }}
                >
                  {vendor.companyName}
                </Typography>
                <Typography variant="h6" sx={{ opacity: 0.9 }}>
                  {vendor.businessType} • {vendor.totalProperties || 0} properties
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ opacity: 0.85, maxWidth: 500 }}
                >
                  {vendor.address?.city}, {vendor.address?.state},{' '}
                  {vendor.address?.country || 'India'}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      <Grid container spacing={4}>
        {/* Left: Details */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={3}>
            {/* Contact Card */}
            <Grid item xs={12}>
              <Card elevation={4} sx={{ borderRadius: 3 }}>
                <CardContent sx={{ p: 4 }}>
                  <Stack direction="row" spacing={3}>
                    <Box
                      sx={{
                        bgcolor: 'primary.50',
                        p: 2,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Email sx={{ fontSize: 30, color: 'primary.main' }} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        gutterBottom
                        color="text.primary"
                      >
                        Contact Information
                      </Typography>
                      <Stack spacing={1.5}>
                        <Stack direction="row" alignItems="center" spacing={1.5}>
                          <Email fontSize="small" color="action" />
                          <Typography variant="body1" fontWeight={500}>
                            {vendor.email}
                          </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1.5}>
                          <Phone fontSize="small" color="action" />
                          <Typography variant="body1" fontWeight={500}>
                            +91 {vendor.phone_number}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Business Details */}
            <Grid item xs={12} md={6}>
              <Card elevation={4} sx={{ borderRadius: 3, height: '100%' }}>
                <CardContent sx={{ p: 4 }}>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    gutterBottom
                    mb={3}
                  >
                    Business Details
                  </Typography>
                  <Stack spacing={2}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="body2" color="text.secondary">
                        GST Number
                      </Typography>
                      <Typography variant="body1" fontWeight={600}>
                        {vendor.gstNumber || 'Not provided'}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="body2" color="text.secondary">
                        PAN Number
                      </Typography>
                      <Typography variant="body1" fontWeight={600}>
                        {vendor.panNumber || 'Not provided'}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="body2" color="text.secondary">
                        Commission Rate
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        color="success.main"
                      >
                        {vendor.commissionRate}%
                      </Typography>
                    </Stack>
                    <Divider />
                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="body2" color="text.secondary">
                        Joined
                      </Typography>
                      <Typography variant="body1" fontWeight={600}>
                        {new Date(vendor.joinedDate).toLocaleDateString('en-IN')}
                      </Typography>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Address */}
            <Grid item xs={12} md={6}>
              <Card elevation={4} sx={{ borderRadius: 3, height: '100%' }}>
                <CardContent sx={{ p: 4 }}>
                  <Stack
                    direction="row"
                    alignItems="flex-start"
                    spacing={2}
                    mb={2}
                  >
                    <LocationOn
                      sx={{ fontSize: 26, color: 'primary.main', mt: 0.3 }}
                    />
                    <Typography variant="h6" fontWeight={700}>
                      Registered Address
                    </Typography>
                  </Stack>
                  <Stack spacing={1}>
                    <Typography variant="body1">
                      {vendor.address?.street || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      {vendor.address?.city}, {vendor.address?.state}
                    </Typography>
                    <Typography variant="body1" fontWeight={600}>
                      PIN: {vendor.address?.pincode || 'N/A'}
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Bank Details Display Card */}
<Grid item xs={12}>
  <Card elevation={4} sx={{ borderRadius: 3 }}>
    <CardContent sx={{ p: 4 }}>
      <Stack direction="row" alignItems="center" spacing={2} mb={3}>
        <AccountBalanceWallet sx={{ fontSize: 26, color: 'primary.main' }} />
        <Typography variant="h6" fontWeight={700}>
          Bank Details
        </Typography>
        {vendor.bankDetails?.accountNumber ? (
          <Chip label="Added" color="success" size="small" />
        ) : (
          <Chip label="Not Added" color="warning" size="small" />
        )}
      </Stack>

      {vendor.bankDetails?.accountNumber ? (
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">Account Holder</Typography>
            <Typography variant="body1" fontWeight={600}>
              {vendor.bankDetails.accountHolderName}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">Account Number</Typography>
            <Typography variant="body1" fontWeight={600} fontFamily="monospace">
              {'•'.repeat(vendor.bankDetails.accountNumber.length - 4)}
              {vendor.bankDetails.accountNumber.slice(-4)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">IFSC Code</Typography>
            <Typography variant="body1" fontWeight={600}>
              {vendor.bankDetails.ifscCode}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">Bank</Typography>
            <Typography variant="body1" fontWeight={600}>
              {vendor.bankDetails.bankName || 'N/A'}
            </Typography>
          </Stack>
          {vendor.bankDetails.upiVpa && (
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">UPI ID</Typography>
              <Typography variant="body1" fontWeight={600}>
                {vendor.bankDetails.upiVpa}
              </Typography>
            </Stack>
          )}
        </Stack>
      ) : (
        <Stack alignItems="center" spacing={2} py={2}>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            No bank details added yet. Add your bank details to receive payouts.
          </Typography>
          <Button
            variant="contained"
            startIcon={<Edit />}
            onClick={() => setEditOpen(true)}
          >
            Add Bank Details
          </Button>
        </Stack>
      )}
    </CardContent>
  </Card>
</Grid>
          </Grid>
        </Grid>

        {/* Right: Stats & Actions */}
        <Grid item xs={12} md={4}>
          <Stack spacing={3}>
            {/* Revenue */}
            <Card
              elevation={6}
              sx={{
                borderRadius: 3,
                p: 4,
                background:
                  'linear-gradient(135deg, #fff7e6 0%, #ffe0b2 100%)'
              }}
            >
              <Stack spacing={2} textAlign="center">
                <MonetizationOn
                  sx={{ fontSize: 44, color: 'warning.main', mx: 'auto' }}
                />
                <Typography variant="h4" fontWeight={800}>
                  ₹{vendor.totalRevenue?.toLocaleString('en-IN') || 0}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  fontWeight={500}
                >
                  Total Revenue
                </Typography>
                <LinearProgress
                  variant="determinate"
                  value={72}
                  sx={{
                    height: 8,
                    borderRadius: 10,
                    bgcolor: 'grey.200'
                  }}
                />
                <Typography variant="caption" color="text.secondary">
                  72% growth vs last period (demo)
                </Typography>
              </Stack>
            </Card>

            {/* Properties */}
            <Card elevation={4} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 4, textAlign: 'center' }}>
                <Hotel
                  sx={{ fontSize: 44, color: 'primary.main', mb: 1.5 }}
                />
                <Typography variant="h4" fontWeight={700}>
                  {vendor.totalProperties || 0}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Active Properties
                </Typography>
              </CardContent>
            </Card>

            {/* Actions */}
            <Card elevation={4} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  gutterBottom
                  mb={2}
                >
                  Quick Actions
                </Typography>
                <Stack spacing={1.5}>
                 <Button
  variant="outlined"
  fullWidth
  startIcon={<FileCopy />}
  onClick={() => setDocsOpen(true)}
>
  Manage Documents ({vendor.documents?.length || 0})
</Button>

                  <Button
  variant="contained"
  fullWidth
  startIcon={<Edit />}
  onClick={() => setEditOpen(true)}
>
  Edit Profile
</Button>

                  <Button
                    variant="text"
                    color="error"
                    fullWidth
                    startIcon={<AccountBalanceWallet />}
                  >
                    View Payouts
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Stack>
        </Grid>
      </Grid>
          {/* Edit Profile Dialog */}
    <Dialog
      open={editOpen}
      onClose={() => setEditOpen(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Edit Vendor Profile</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} mt={1}>
          <TextField
            label="Company Name"
            name="companyName"
            value={form.companyName}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Business Type"
            name="businessType"
            value={form.businessType}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Registration Number"
            name="registrationNumber"
            value={form.registrationNumber}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="GST Number"
            name="gstNumber"
            value={form.gstNumber}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="PAN Number"
            name="panNumber"
            value={form.panNumber}
            onChange={handleChange}
            fullWidth
          />
          <Divider sx={{ my: 1 }} />
          <TextField
            label="Street"
            name="street"
            value={form.street}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="City"
            name="city"
            value={form.city}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="State"
            name="state"
            value={form.state}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Pincode"
            name="pincode"
            value={form.pincode}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Country"
            name="country"
            value={form.country}
            onChange={handleChange}
            fullWidth
          />
          {/* Bank Details Section */}
<Divider sx={{ my: 1 }} />
<Typography variant="subtitle1" fontWeight={700} color="primary">
  Bank Details (for payouts)
</Typography>

<TextField
  label="Account Holder Name"
  name="accountHolderName"
  value={form.accountHolderName}
  onChange={handleChange}
  fullWidth
/>
<TextField
  label="Account Number"
  name="accountNumber"
  value={form.accountNumber}
  onChange={handleChange}
  fullWidth
/>
<TextField
  label="IFSC Code"
  name="ifscCode"
  value={form.ifscCode}
  onChange={handleChange}
  fullWidth
  inputProps={{ style: { textTransform: 'uppercase' } }}
/>
<TextField
  label="Bank Name"
  name="bankName"
  value={form.bankName}
  onChange={handleChange}
  fullWidth
/>
<TextField
  label="Branch"
  name="branch"
  value={form.branch}
  onChange={handleChange}
  fullWidth
/>
<FormControl fullWidth>
  <InputLabel>Account Type</InputLabel>
  <Select
    name="accountType"
    value={form.accountType}
    label="Account Type"
    onChange={handleChange}
  >
    <MenuItem value="savings">Savings</MenuItem>
    <MenuItem value="current">Current</MenuItem>
  </Select>
</FormControl>

<Divider sx={{ my: 1 }} />
<Typography variant="subtitle2" color="text.secondary">
  UPI Details (optional)
</Typography>
<TextField
  label="UPI ID"
  name="upiVpa"
  value={form.upiVpa}
  onChange={handleChange}
  fullWidth
  placeholder="example@upi"
/>
<TextField
  label="UPI Name"
  name="upiName"
  value={form.upiName}
  onChange={handleChange}
  fullWidth
/>
        </Stack>
      </DialogContent>
     <DialogActions>
  <Button onClick={() => setEditOpen(false)}>Cancel</Button>
  <Button
    variant="outlined"
    color="success"
    onClick={handleSaveBankDetails}
  >
    Save Bank Details
  </Button>
  <Button variant="contained" onClick={handleUpdate}>
    Save Profile
  </Button>
</DialogActions>
    </Dialog>
<Snackbar
  open={snackbar.open}
  autoHideDuration={4000}
  onClose={handleCloseSnackbar}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <MuiAlert
    onClose={handleCloseSnackbar}
    severity={snackbar.severity}
    variant="filled"
    sx={{ width: '100%' }}
  >
    {snackbar.message}
  </MuiAlert>
</Snackbar>

{/* Manage Documents Dialog */}
<Dialog
  open={docsOpen}
  onClose={() => setDocsOpen(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Manage Documents</DialogTitle>
  <DialogContent dividers>
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        Upload PDFs or images (GST, PAN, licenses, etc.).
      </Typography>

      {/* Existing docs list */}
      {(form.documents || []).length > 0 && (
        <Stack spacing={1}>
          {form.documents.map((doc, idx) => (
            <Stack
              key={idx}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Typography variant="body2">
                {doc.type || 'Document'} – {doc.uploadedAt ? new Date(doc.uploadedAt).toLocaleDateString('en-IN') : ''}
              </Typography>
              <Stack direction="row" spacing={1}>
                {doc.url && (
                  <Button
                    size="small"
                    href={doc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View
                  </Button>
                )}
                <Button
                  size="small"
                  color="error"
                  onClick={async () => {
                    try {
                      const updated = form.documents.filter((_, i) => i !== idx);
                      await updateDocumentsInDb(updated);
                      setSnackbar({
                        open: true,
                        message: 'Document removed',
                        severity: 'success',
                      });
                    } catch (err) {
                      console.error('Remove doc error:', err);
                      setSnackbar({
                        open: true,
                        message: 'Failed to remove document',
                        severity: 'error',
                      });
                    }
                  }}
                >
                  Delete
                </Button>
              </Stack>
            </Stack>
          ))}
        </Stack>
      )}
<FormControl size="small" fullWidth>
  <InputLabel id="doc-type-label">Document Type</InputLabel>
  <Select
    labelId="doc-type-label"
    label="Document Type"
    value={newDocType}
    onChange={(e) => setNewDocType(e.target.value)}
  >
    <MenuItem value="GST Certificate">GST Certificate</MenuItem>
    <MenuItem value="PAN Card">PAN Card</MenuItem>
    <MenuItem value="Business License">Business License</MenuItem>
    <MenuItem value="Aadhar Card">Aadhar Card</MenuItem>
    <MenuItem value="Other">Other</MenuItem>
  </Select>
</FormControl>


      {/* File picker */}
      <Button
        variant="outlined"
        component="label"
        disabled={uploading}
      >
        Select Document
        <input
          type="file"
          hidden
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,image/*"
          onChange={async (e) => {
            const file = e.target.files?.[0];
            if (!file || !vendor) return;
            try {
              setUploading(true);
              const url = await uploadDocumentToFirebase(file);

              const newDoc = {
  type: newDocType || 'Other',
  url,
  uploadedAt: new Date().toISOString(),
};

              const updatedDocs = [...(form.documents || []), newDoc];

              await updateDocumentsInDb(updatedDocs);

              setSnackbar({
                open: true,
                message: 'Document uploaded successfully',
                severity: 'success',
              });
            } catch (err) {
              console.error('Upload doc error:', err);
              setSnackbar({
                open: true,
                message: 'Failed to upload document',
                severity: 'error',
              });
            } finally {
              setUploading(false);
              e.target.value = ''; 
            }
          }}
        />
      </Button>

      {uploading && (
        <Typography variant="body2" color="text.secondary">
          Uploading...
        </Typography>
      )}
    </Stack>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDocsOpen(false)} disabled={uploading}>
      Close
    </Button>
  </DialogActions>
</Dialog>


    </Box>
  );
  
};

export default VendorProfile;
